export const layoutConstants = {

    // set app language
    SET_LANGUAGE: 'SET_LANGUAGE',
    GermanLanguage: "de-DE",
    EnglishLanguage: "en-GB"
};